import styled from "styled-components";

export const ShoppingCartWrapper = styled.div`
  margin-left: auto;
  margin-right: 16px;
  position: relative;

  > button {
    font-size: 20px;
    padding: 0;
  }

  .icon-left {
    font-size: 24px;
  }

  .mobile {
    overflow-wrap: normal;

    @media (min-width: 768px) {
      display: none;
    }
  }

  .desktop {
    overflow-wrap: normal;

    @media (max-width: 768px) {
      display: none;
    }
  }

  .number {
    /* background-color: var(--color-primary); */
    background-color: var(--p-color-red-600);
    border-radius: 40.91px;
    color: var(--color-on-primary);
    font-size: 10px;
    padding: 2px 5px;
    position: absolute;
    right: -9px;
    text-align-last: center;
    top: 6px;
  }
`;
